import axios from "axios";
import { environment } from "../../../environments/environment";

export function getInventoryList(
  page = 0,
  pageSize = 10,
  tabIndex,
  filters,
  dropdownColumnMap,
  search,
  sortingOrder
) {
  let filterArray = [
    ...Object.entries(filters?.dropdowns ?? {})
      .map(([dropdownId, values]) => ({
        columnName: dropdownColumnMap[dropdownId],
        value: values.map((dropdown) => dropdown.id),
      }))
      .filter((dropdown) => dropdown?.value?.length > 0),
    ...Object.entries(filters?.txt ?? {})
      .filter(([columnName, value]) => Boolean(value))
      .map(([columnName, value]) => ({
        columnName,
        value,
      })),
  ];
  const companies = JSON.parse(localStorage.getItem("u_companies"));
  let companyIds = companies.map((e) => e.id);
  filterArray.push({
    columnName: "company_id",
    value: companyIds,
  });
  return axios.post(
    `${environment.getInventoryList}?page=${page}&pageSize=${pageSize}&type=${tabIndex}&search=${search}&orderBy=${sortingOrder}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export function getPartInfo(partId) {
  return axios.get(environment.getPartConfigurationInfo + "?partId=" + partId, {
    hideLoader: true,
  });
}

export function getPartTransacctionHistory(partId, internalBatch) {
  return axios.get(
    environment.getPartTransacctionHistory +
      "?partId=" +
      partId +
      "&batchNumber=" +
      internalBatch,
    {
      hideLoader: true,
    }
  );
}

export function getTimeControlsByPart(serializedPartId) {
  return axios.get(
    environment.getTimeControlsByPart +
      "?serializedPartId=" +
      serializedPartId +
      "&companyId=" +
      localStorage.getItem("u_company_id"),
    {
      hideLoader: true,
    }
  );
}

export function getPartLocationHistory(partId, internalBatch) {
  return axios.get(
    environment.getPartLocationHistory +
      "?partId=" +
      partId +
      "&batchNumber=" +
      internalBatch,
    {
      hideLoader: true,
    }
  );
}
export function downloadFile(data, container) {
  return axios.get(
    environment.downloadFile +
      "?fileId=" +
      data +
      "&containerName=" +
      container,
    {
      responseType: "blob", // Necesario para archivos binarios
      headers: {
        Accept: "*/*",
      },
    }
  );
}
export function getInventoryAdditionalPartInfo(serializedPartId, batchId) {
  let extraParam = "";
  if (batchId) {
    extraParam = "&batchId=" + batchId;
  }

  return axios.get(
    environment.getInventoryAdditionalPartInfo +
      "?serializedPartId=" +
      (serializedPartId ? serializedPartId : "") +
      extraParam,
    {
      hideLoader: true,
    }
  );
}

export function getPartPositionInformation(serializedPartId, aircraftId) {
  let extraParam = "";
  if (aircraftId) {
    extraParam = "&aircraftId=" + aircraftId;
  }
  return axios.get(
    environment.getPartPositionInformation +
      "?serializedPartId=" +
      serializedPartId +
      extraParam,
    {
      hideLoader: true,
    }
  );
}

export function getPartRequestInfoByPart(
  page = 0,
  pageSize = 300,
  search,
  sortingOrder,
  partId,
  internalBatch
) {
  let filterArray = [];
  const companies = JSON.parse(localStorage.getItem("u_companies"));
  let companyIds = companies.map((e) => e.id);
  filterArray.push({
    columnName: "company_id",
    value: companyIds,
  });
  return axios.post(
    `${environment.getPartRequestInfoByPart}?page=${page}&pageSize=${pageSize}&search=${search}&orderBy=${sortingOrder}&partId=${partId}&batchId=${internalBatch}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export function getTaskCardsFindingsByPart(
  page = 0,
  pageSize = 10,
  search,
  sortingOrder,
  partId
) {
  const companies = JSON.parse(localStorage.getItem("u_companies"));
  let companyIds = companies.map((e) => e.id);
  let filterArray = [
    {
      columnName: "company_id",
      value: companyIds,
    },
  ];
  return axios.post(
    `${environment.getTaskCardsFindingsByPart}?page=${page}&pageSize=${pageSize}&search=${search}&orderBy=${sortingOrder}&partId=${partId}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}
